import moment from 'moment-timezone';

const getHoursDiffBetweenTimeZones = (
	baseTimeZone: string,
	timeZone: string,
	dateIsoString: string = new Date().toISOString()
) => {
	const baseMoment = moment.tz(dateIsoString, baseTimeZone);
	const targetMoment = moment.tz(dateIsoString, timeZone);

	return (targetMoment.utcOffset() - baseMoment.utcOffset()) / 60;
};

const getStringHoursDiffBetweenTimeZones = (baseTimeZone: string, timeZone: string, dateIsoString?: string) => {
	const hoursDiff = getHoursDiffBetweenTimeZones(baseTimeZone, timeZone, dateIsoString);
	return `${hoursDiff < 0 ? '-' : '+'}${Math.abs(hoursDiff)}`;
};

const getTimeZoneAbbreviation = (timeZone: string, timestamp = Date.now()) => {
	const timeZoneObject = moment.tz.zone(timeZone);
	return timeZoneObject ? timeZoneObject.abbr(timestamp) : timeZone;
};

export const timeZoneUtils = {
	getStringHoursDiffBetweenTimeZones,
	getTimeZoneAbbreviation
};
